import React from "react";
import { Bar } from "react-chartjs-2";
import { dataForDayTemplate, dataForLucketTemplate } from "../chartTemplates";
import { countDoneBuckets } from "../../../components/buckets/slice/lucket-model/countBuckets";

export default function TotalPointsByDay({allLuckets, chartTimeframe}){

    const options1 =  {
        scales: {
            y: {
            beginAtZero: true
            }
        }
    }
    // let parentLucketsASPoints = filteredBuckets.reduce((acc,v,i,ar)=>{
    //     acc[i] = v.weekPoints
    //     return acc
    // },[])
    let minimumDate = new Date(allLuckets[0].date)
    let maximumDate = new Date(allLuckets[allLuckets.length -1].date)
    let currDate = minimumDate
    let arrayOfDates = []
     
    while(currDate<=maximumDate){
        arrayOfDates.push(currDate.toLocaleDateString())
        currDate.setDate(currDate.getDate() + 1)
    }
    if(chartTimeframe=="week"){
        arrayOfDates = arrayOfDates.slice(arrayOfDates.length-8,arrayOfDates.length-1)
    }
    else if(chartTimeframe=="month"){
        arrayOfDates = arrayOfDates.slice(arrayOfDates.length-31,arrayOfDates.length-1)
    }
     
    let data = arrayOfDates.reduce((acc,v,i,ar)=>{
        let count = countDoneBuckets(allLuckets,v)
        acc.push(count)
        return acc
    },[])
    let colours = arrayOfDates.map(_=>"lightgrey")

    // let parentLuckets = filteredBuckets.filter(l=>!l.parentRowID)
    // let labels = parentLuckets.map(l=>l.name)
 
    // let backgroundColors = parentLuckets.map(l=>l.weekActionStatus)
 

    return <Bar
              type="bar"
              options={options1}
              data={dataForLucketTemplate(data, colours, arrayOfDates, "Total Done Day Points by Day ")}
              />
}
